<template>
	<div class="parkAdd">
		<div class="contentWrap"   element-loading-spinner="el-icon-loading" element-loading-background="rgba(255, 255, 255, 0.8)">
			<!-- 第一块 -->
			<div class="panelBlock">
				<div class="panelTitle"> <i class="red">*</i> <span>园区展览图（可传多张，建议600*400像素）</span>  </div>
				<div class="panelContent myFixedRateImgUpload">
          <!-- {{JSON.stringify(multiImgInfoArr_string) }} -->
          <el-upload
           :on-preview="handlePictureCardPreview" :on-remove="handleRemove" :file-list="multiImgInfoArr_string"
           :name="'files'" :data="uploadData" :action="api.baseUrl+'/file/uploadfilebatch'" :on-success="addImgSuccessHandle"
           list-type="picture-card">
            <div class="mytriggerDiv" slot="trigger" @click="addImgClick('multi')"><i class="el-icon-plus avatar-uploader-icon"></i></div>
          </el-upload>
          <el-dialog :visible.sync="dialogVisible">  <img width="100%" :src="dialogImageUrl" alt="">    </el-dialog>

				</div>
			</div>
			<!-- 第2块 -->
      <div class="panelBlock">
      	<div class="panelTitle"><span>园区小头像（只能1张,建议200*200像素）</span>	</div>
      	<div class="panelContent myFixedRateImgUpload">
          <!-- {{JSON.stringify(smallAvatarImgInfoArr_string) }} -->
          <el-upload
           :on-preview="handlePictureCardPreview" :on-remove="handleRemove" :limit="1" :on-exceed="exceedHandle" :file-list="smallAvatarImgInfoArr_string"
           :name="'files'" :data="uploadData" :action="api.baseUrl+'/file/uploadfilebatch'" :on-success="addImgSuccessHandle"
           list-type="picture-card">
            <div class="mytriggerDiv" slot="trigger" @click="addImgClick('smallAvatar')"><i class="el-icon-plus avatar-uploader-icon"></i></div>
          </el-upload>
          <el-dialog :visible.sync="dialogVisible">  <img width="100%" :src="dialogImageUrl" alt="">    </el-dialog>

      	</div>
      </div>
      <!-- 第三块 -->
      <div class="panelBlock">
      	<div class="panelTitle"><span>其他信息</span></div>
      	<div class="panelContent">
          <div class="oneLine">
            <div class="label"> <i class="red">*</i> 园区/场地名称</div>
            <div class="rightInput">
              <input type="text" class="input" placeholder="请输入园区/场地名称" v-model="parkName">
            </div>
            <div class="label"> <i class="red">*</i> 园区图标在地图上层级排序（数字越大越靠上）</div>
            <div class="rightInput">
              <el-input-number v-model="parkMapSequence"  :min="0" :max="100000000" label="描述文字"></el-input-number>
            </div>

          </div>
          <div class="oneLine">
            <div class="label"> <i class="red">*</i> 联系人姓名</div>
            <div class="rightInput">
              <input type="text" class="input" placeholder="请输入园区联系人姓名" v-model="contactName">
            </div>
            <div class="label"> <i class="red">*</i> 联系人手机</div>
            <div class="rightInput">
              <input type="text" class="input" placeholder="请输入园区联系人手机" v-model="contactPhone">
            </div>
          </div>
          <div class="oneLine">
            <div class="label"> <i class="red">*</i>  园区/场地地址</div>
            <div class="rightInput">
              <addressSelect :proviceId="proviceId" :cityId="cityId" :distId="distId"  @changeSelect="changeAddress"></addressSelect>
              <!-- <el-cascader placeholder="点击选择地址" :clearable="true" ref="cascader" :props="props"  @change="handleChangeAddress"></el-cascader> -->
              <input type="text" class="input" placeholder="请输入详细地址" v-model="addressDetail">
            </div>
            <div class="label"><i class="red">*</i> 经度</div>
            <div class="rightInput">
              <input type="text" class="input" placeholder="请输入经度" v-model="parkLongitude" style="width: 100px;">
            </div>
            <div class="label"><i class="red">*</i> 纬度</div>
            <div class="rightInput">
              <input type="text" class="input" placeholder="请输入纬度" v-model="parkLatitude"  style="width: 100px;">
            </div>
          </div>
          <div class="oneLine">
            <div class="rightInput">
              <div id="mapContainer"></div>
            </div>
          </div>
          <div class="oneLine">
            <div class="label">园区标签</div>
            <div class="rightInput">
             <!-- <span v-if="!storeTagArr||storeTagArr.length==0" style="margin-right: 20px;">未填写标签</span>
              <span  v-for="(list,index) in storeTagArr" style="margin-right: 30px;"> <span  class="tagBox">{{list}}</span>
                <span @click="deleteTag(index)" class="deleteIcon" ><i class="el-icon-delete"></i></span>
              </span>
              -->
              <!-- <div class="storeTagItem" v-for="(list,index) in list_tag_park" :class="{active:list.isChosed==true}" @click="choseTag(list)">
                <img :src="list.tag_icon" alt="">
                <div class="text">{{list.tag_name}}</div>
              </div> -->
              <tagSelect  :type="'park'" @clickItem="getTag"></tagSelect>

            </div>
            <!-- <div class="rightInput">
              <input type="text" class="input" placeholder="请输入标签" v-model="storeTagTemp">
            </div>
            <div class="label"><el-button type='primary' @click="addTag">点击新增标签</el-button></div> -->
          </div>
          <div class="oneLine">
            <div class="label">园区地图上显示图标</div>
            <div class="rightInput">
              <tagSelect  :type="'map_park'" @clickItem="getIcon" :num="1"></tagSelect>
            </div>
          </div>
          <div class="oneLine">
            <div class="label">园区简介</div>
            <div class="rightInput">
              <textarea name="" id="" cols="100" rows="10" v-model="parkIntro" placeholder="请输入园区简介"></textarea>
            </div>
          </div>
      	</div>
      </div>

      <!-- button -->
      <div class="btnBox">
        <el-button type='primary' @click="submitClick">提交</el-button>
      </div>

		</div>
	</div>
</template>

<script>
	import {json,wordData,utils} from '@/common/common.js'
	import { ajaxPost,api } from '@/common/request.js'
  import AMap from 'AMap'
  import addressSelect from '@/components/addressSelect'
  // import {      ajaxApp} from '@/common/request_app.js'
	export default {
		name: 'adminIndex',
		data() {
			return {
        dialogImageUrl: '',
        dialogVisible: false,
        parkName:'',
        parkMapSequence:0,
        contactName:'',
        contactPhone:'',
        parkIntro :'',
        tagArr:[],
        parkLongitude :'',
        parkLatitude :'',
        list_tag_park_arr:[],
        park_map_icon: [],
        imageType:'',//11101  园区头部图(即多图展示)  11201 园区方形小图（单张小头像）   11301 商家店面图  11401 品牌图111501 商品图
        uploadData:{},
        // multiImgInfoArr:[],//存储图片名字和其后台返回的id
        multiImgInfoArr_string:[],//存储图片名字和其后台返回的id
        smallAvatarImgInfoArr_string:[],//存储图片名字和其后台返回的id
        // ditu
        proviceText:"",
        cityText:'',
        distText:'',
        proviceId:"",
        cityId:'',
        distId:'',
        // addressValue:'',
        addressDetail:'',//详细地址
        // addressOptions:[],
        // props: {
        //   lazy: true,
        //   lazyLoad (node, resolve) {
        //     console.log(node)
        //     const { level }=node;
        //     let nodeId=node.value||0
        //     let arg={parentId:nodeId}
        //     ajaxPost('/globalRegionInfo/regionInfo', arg).then(function(res) {
        //         if (res.errorCode == 200) {
        //           let lists=res.data||[{region_id:node.value+'mm',region_name:node.label}]
        //           // let lists=res.data
        //           let newArr=lists.map(function(item,index){
        //             let buffer={
        //               value:item.region_id,
        //               label:item.region_name,
        //               leaf:level>=2,
        //             }
        //             return buffer
        //           })
        //           resolve(newArr);
        //         }
        //     }, function(res) {
        //     })

        //   }
        // }



			}
		},
		computed: {
			IMG_PREV(){
				return api.imgPrev
			},
      api(){
        return api
      },
      adminId() {
          return utils.getAdminId()
      },
		},
		components: {addressSelect},
		methods: {
      choseTag(list){
        list.isChosed=!list.isChosed
      },
      getTag(data){
        this.list_tag_park_arr=data
      },

      getIcon(data) {
        this.park_map_icon=data;
      },
      // getTagList_park(){
      //   let _this=this
      //   console.log(arg)
      //   let arg={tagType:"park"}
      //   ajaxPost('/tag/tagList', arg).then(function(res) {
      //     if(res.errorCode==200){
      //       _this.list_tag_park=res.data.map(function(item,index){
      //         item.isChosed=false
      //         return item
      //       })

      //     }else{

      //     }
      //   }, function(res) {})
      // },
      initMap() {
        let _this=this
        let map = new AMap.Map('mapContainer', {
          center: [120.274301, 30.358863],
          resizeEnable: true,
          zoom: 14,
          viewMode:'3D'//使用3D视图
        })
        AMap.plugin(['AMap.ToolBar', 'AMap.Scale'], function () {
          map.addControl(new AMap.ToolBar())
          map.addControl(new AMap.Scale())
        })
        let marker=''
        map.on("click",function(ev){
          var lnglat = ev.lnglat;
          console.log("点击地图")
          var lng=ev.lnglat.getLng()
          var lat=ev.lnglat.getLat()
          _this.parkLongitude=lng//经度
          _this.parkLatitude=lat//维度
          console.log(lng,lat)
          map.remove(marker);
          marker = new AMap.Marker({
              position: new AMap.LngLat(lng, lat),   // 经纬度对象，也可以是经纬度构成的一维数组[116.39, 39.9]
              // title: '北京'
          });
          // 将创建的点标记添加到已有的地图实例：
          map.add(marker);
        })
      },
      submitClick(){
        let _this=this
        if(!_this.contactName){
          _this.$message({
               message: "园区联系人必填",
               type: 'error',
          });
          return false
        }
        if(!_this.contactPhone){
          _this.$message({
               message: "园区联系人手机号必填",
               type: 'error',
          });
          return false
        }
        if(!json.phoneReg.test(this.contactPhone)){
          _this.$message({
               message: "手机号格式不正确",
               type: 'error',
          });
          return false
        }
        if(!_this.parkName){
          _this.$message({
               message: "园区姓名为必填项",
               type: 'error',
          });
          return false
        }
        if(isNaN(_this.parkMapSequence)||_this.parkMapSequence<0){
          _this.$message({
               message: "园区排序只能为大于等于0的数字",
               type: 'error',
          });
          return false
        }
        if(!_this.proviceId||!_this.cityId ){
          _this.$message({
               message: "地址为必填项",
               type: 'error',
          });
          return false
        }
        if(!_this.parkLongitude||!_this.parkLatitude){
          _this.$message({
               message: "经纬度为必填项",
               type: 'error',
          });
          return false
        }
        if(!_this.multiImgInfoArr_string||_this.multiImgInfoArr_string.length==0){
          _this.$message({
               message: "园区展览图至少传一张",
               type: 'error',
          });
          return false
        }
        // if (this.park_map_icon.length != 1) {
        //   _this.$message({
        //        message: "请选择一张园区地图图标",
        //        type: 'error',
        //   });
        //   return false
        // }

        let arg={
          "parkContactCellphone":_this.contactPhone,
          "parkContactName":_this.contactName,
          "parkName":_this.parkName,
          "parkMapSequence":_this.parkMapSequence,
          "parkIntro":_this.parkIntro,
          "regionProvinceId":_this.proviceId,
          "regionProvinceString":_this.proviceText,
          "regionCityId":_this.cityId,
          "regionCityString":_this.cityText,
          "regionDistrictId":_this.distId,
          "regionDistrictString":_this.distText,
          "addressString":_this.addressDetail,
          "parkLongitude":_this.parkLongitude,
          "parkLatitude":_this.parkLatitude,
          "adminId":_this.adminId,
          "storeTag":_this.list_tag_park_arr.join(","),
          "mapPark": _this.park_map_icon[0],
          "storeBigPic":utils.turnImgIdToJson(_this.multiImgInfoArr_string),
          "storeSmallPic":utils.turnImgIdToJson(_this.smallAvatarImgInfoArr_string),
        }
        console.log(arg)
        ajaxPost('/park/addPark', arg).then(function(res) {
          if(res.errorCode==200){
            _this.$message({
               message: "新增成功",
               type: 'success',
            });
            _this.$router.push("/park/list")
          }else{
            _this.$message({
               message: res.errorMsg,
               type: 'error',
            });
          }
        }, function(res) {})
      },

      changeAddress(data){
        // console.log(JSON.stringify(data))
        this.proviceId=data.proviceId
        this.proviceText=data.proviceText
        this.cityId=data.cityId
        this.cityText=data.cityText
        this.distId=data.distId
        this.distText=data.distText
      },

      // handleChangeAddress(value){//更改地址
      //   console.log("地址change")
      //   let nodesObj = this.$refs['cascader'].getCheckedNodes()
      //   // console.log(nodesObj)
      //   var valueArr=nodesObj[0].path
      //   var TextArr=nodesObj[0].pathLabels
      //   console.log(valueArr)
      //   console.log(TextArr)
      //   // proviceText
      //   this.proviceId=valueArr[0]
      //   this.cityId=valueArr[1]
      //   this.distId=valueArr[2]&&valueArr[2].length==6?valueArr[2]:''
      //   this.proviceText=TextArr[0]
      //   this.cityText=TextArr[1]
      //   this.distText=this.distId?TextArr[2]:''
      // },
			back(){
				this.$router.back()
			},
      exceedHandle(){
        alert("只允许上传一张")
      },
      handleRemove(file, fileList) {
        if(file.wwType=='11101'){
          console.log("删除的是多图")
          // this.multiImgInfoArr_string=this.computeImgIdArrToString(fileList)
          this.multiImgInfoArr_string=fileList
        }
        if(file.wwType=='11201'){
          console.log("删除的是单图")
          // this.smallAvatarImgInfoArr_string=this.computeImgIdArrToString(fileList)
          this.smallAvatarImgInfoArr_string=fileList

        }
      },
      handlePictureCardPreview(file) {
        console.log(this.imageType)
        console.log("预览图片---")
        this.dialogImageUrl = file.url;
        this.dialogVisible = true;
      },
      addImgClick(type){//点击不同的图片上传按钮，设置imagetype及图片data
        console.log('点击上传按钮---'+type)
        if(type=='multi'){
           this.imageType=11101
           this.uploadData = {
               imageType: this.imageType,
               imageUserId: this.adminId,
           }
           // console.log(this.uploadData)
        }
        if(type=='smallAvatar'){
           this.imageType=11201
           this.uploadData = {
               imageType: this.imageType,
               imageUserId: this.adminId,
           }
           // console.log(this.uploadData)
        }
      },
      initAddress(){
        this.proviceText= "浙江"
        this.cityText= '杭州'
        this.distText= '余杭区'
        this.proviceId= "330000"
        this.cityId= '330100'
        this.distId= '330110'
      },
      computeImgIdArrToString(fileList){
        let resultArr=[]
        for(var i=0;i<fileList.length;i++){
          let oneItem=fileList[i]
          let obj=oneItem.wwId
          console.log(obj)
          resultArr.push(obj)

        }
        console.log(resultArr)
        return resultArr
      },
      addImgSuccessHandle(res, file,fileList){//自动上传成功以后的操作
        console.log("上传图片成功---")
        console.log(this.imageType)
        console.log(file, fileList);
        if(res.errorCode==200){
          file.wwId=res.data
          file.wwType=this.imageType
          if(this.imageType=='11101'){
            // this.multiImgInfoArr_string=this.computeImgIdArrToString(fileList)
            this.multiImgInfoArr_string=fileList
          }
          if(this.imageType=='11201'){
            // this.smallAvatarImgInfoArr_string=this.computeImgIdArrToString(fileList)
            this.smallAvatarImgInfoArr_string=fileList
          }
        }

      },

		},
		mounted() {
			let _this = this
      this.initMap()
      this.initAddress()
      // this.getTagList_park()
		},
		destroyed(){
		}
	}

</script>

<style scoped lang="scss">
	* {
		// outline: 1px solid blue;
	}
  #mapContainer {width:900px; height: 500px;border:1px solid #eee;}
  .storeTagItem:hover{border:1px solid #aaf;}
  .storeTagItem.active{background: #ddfeff;border-color:blue; box-shadow: 0 0 3px #ddd;}
  .storeTagItem{border:1px solid #ddd;padding:5px;display: inline-block;margin-right: 5px;cursor:pointer; border-radius: 6px;
    img{width: 50px;height: 50px;} text-align: center;
  }
  .parkAdd{
    input{height: 28px;}
    textarea{border:1px solid #ddd;border-radius: 6px;}
    .tagBox{margin-right: 5px;border:1px solid royalblue;background-color: royalblue; color:#fff; border-radius: 6px; padding:2px 5px;}
    .deleteIcon{color:blue;cursor: pointer;position: relative;top:-10px;left:-10px;}
    textarea{vertical-align: top;}
    background: #fff;; padding:20px;padding-bottom:100px;
    .panelBlock{
      .panelTitle{font-weight: bold;padding:10px 0;}
      .panelContent{
        .oneLine{
          padding:10px;
          .label{display: inline-block;padding:0 20px;}
          .rightInput{display: inline-block;}
        }
      }
    }
    .btnBox{text-align: center;}
  }

</style>



// WEBPACK FOOTER //
// src/pages/park/add.vue